import { render, staticRenderFns } from "./customer-details-modal.vue?vue&type=template&id=2b52dbbc&scoped=true"
import script from "./customer-details-modal.vue?vue&type=script&lang=js"
export * from "./customer-details-modal.vue?vue&type=script&lang=js"
import style0 from "./customer-details-modal.vue?vue&type=style&index=0&id=2b52dbbc&prod&scoped=true&lang=scss"
import style1 from "./customer-details-modal.vue?vue&type=style&index=1&id=2b52dbbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52dbbc",
  null
  
)

export default component.exports